import { Box, Container, Grid } from "@mui/material";
import Link from "next/link";
import { getBlogDateFormatted } from "../../helpers/getDateFormatted";
import cssVars from '../../styles/vars.module.scss'
import Pagination from "../pagination";

const Blogs = ({ blogs, pageInfo, forJobs = false }) => {
    return (
        <Container maxWidth="xl">

            <Grid container spacing="30px" columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} mb={5}>
                {
                    blogs?.map((blog, i) => (
                        <Grid item xs={1} key={blog.url_key}>
                            <Link href={`/${forJobs ? 'career' : 'blogs'}/${blog.url_key}.html`}>
                                <Box borderRadius={cssVars.radius} border={`1px solid ${cssVars.lightGray}`}>
                                    <Box position="relative" mb={3}
                                        sx={{
                                            borderTopLeftRadius: cssVars.radius,
                                            borderTopRightRadius: cssVars.radius,
                                            height: blog.image ? 253 : 0,
                                            backgroundOrigin: "content-box",
                                            backgroundImage: `url(${blog.image})`,
                                            backgroundSize: "cover",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            overflow: "hidden"
                                        }} />

                                    <Box px="20px">
                                        <Box fontWeight={500} className="dots1">{blog.name}</Box>
                                        <Box component="p" className="dots2">
                                            {blog.short_description}
                                        </Box>
                                        <Box component="p" color={cssVars.darkGray} fontWeight={600}>
                                            {getBlogDateFormatted(blog.publish_date)}
                                        </Box>
                                    </Box>
                                </Box>
                            </Link>
                        </Grid>
                    ))
                }
            </Grid>
            <Pagination pageCount={pageInfo.endPage} btnCount={3} currPage={pageInfo.currentPage} />
        </Container>
    );
}

export default Blogs;